<span class="rating-star">
  <fa-icon [icon]="faStar" class="rating-star__icon rating-star__background"></fa-icon>
  <fa-icon
    [icon]="faStar"
    *ngIf="starPercentage > 0"
    class="rating-star__icon rating-star__foreground"
    [style.width.%]="starPercentage * 100">
  </fa-icon>
</span>
